// Who put a report on a chart — shared by every surface that lists reports so
// the "PATIENT" badge can't drift between them.
//
// The authoritative signal is `metadata.uploaded_by_role === 'patient'`, which
// only `api/patient_reports.build_patient_cache_row` writes (behind a verified
// JWT). `uploaded_by_name` is a display string a staff account could in
// principle be named to imitate, so it is used only as a fallback for rows
// written before the metadata flag existed — never as the primary check.

export function isPatientUpload(metadata, uploadedByName) {
  if (metadata && typeof metadata === "object" && metadata.uploaded_by_role) {
    return metadata.uploaded_by_role === "patient";
  }
  return /^PATIENT\s+/i.test(String(uploadedByName || ""));
}

/** Patient's name without the "PATIENT " prefix, for a badge that supplies it. */
export function patientUploaderName(metadata, uploadedByName) {
  const fromMeta =
    metadata && typeof metadata === "object"
      ? String(metadata.uploaded_by_patient_name || "").trim()
      : "";
  if (fromMeta) return fromMeta;
  return String(uploadedByName || "").replace(/^PATIENT\s+/i, "").trim();
}

/** Full badge text, e.g. "PATIENT Pat, Nep". */
export function patientUploadLabel(metadata, uploadedByName) {
  const name = patientUploaderName(metadata, uploadedByName);
  return name ? `PATIENT ${name}` : "PATIENT UPLOAD";
}
